const modalCrearAlerta = {
  'Crear alerta de nuevos trabajos': 'Crear alerta de nuevos empleos',
  'Recibí por email los avisos de trabajo que coincidan con los filtros que aplicaste en esta búsqueda':
    'Recibe por email los avisos de empleo que coincidan con los filtros que aplicaste en esta búsqueda.',
}

export default modalCrearAlerta
